<template>
  <li
    class="rounded-md border shadow-sm"
    :class="[{ 'bg-secondary': highlighted }, isCompact ? 'text-sm' : '']"
  >
    <button
      class="flex w-full items-center justify-between space-x-4 text-left"
      :class="isCompact ? 'px-2 py-1.5' : 'px-2 py-2'"
    >
      <div class="flex min-w-0 items-center space-x-2">
        <RenderFeatureIcon
          :name="category"
          alt="icon"
          :width="isCompact ? 24 : 32"
          :height="isCompact ? 24 : 32"
        />
        <div class="min-w-0">
          <div class="truncate font-medium" :class="isCompact ? 'text-sm' : ''">
            <span v-if="category === 'registry'">{{ (item as any).registry }}</span>
            <span v-else>{{ getItemName(item) }}</span>
          </div>
          <div class="text-muted-foreground text-xs">
            <span v-if="category === 'stacklet' && 'ipv4Address' in item">{{
              item.ipv4Address
            }}</span>
            <span v-if="category === 'bucket' && 'regionSlug' in item">{{
              (item as any).regionSlug
            }}</span>
            <span v-if="category === 'registry' && 'repository' in item">{{
              (item as any).repository
            }}</span>
          </div>
        </div>
      </div>
      <div class="shrink-0">
        <ChevronRightIcon :class="isCompact ? 'size-4' : 'size-5'" />
      </div>
    </button>
  </li>
</template>

<script setup lang="ts">
import { ChevronRightIcon } from 'lucide-vue-next';
import { computed } from 'vue';

import type { Results } from '@/entities/search';
import RenderFeatureIcon from '@/shared/ui/render-feature-icon.vue';

const props = withDefaults(
  defineProps<{
    item: Results;
    category: string;
    highlighted: boolean;
    density?: 'default' | 'compact';
  }>(),
  {
    density: 'default',
  },
);

const isCompact = computed(() => props.density === 'compact');

const getItemName = (item: Results): string => {
  switch (item.type) {
    case 'stacklet':
    case 'baremetal':
      return item.name;
    case 'database':
    case 'firewall':
    case 'kubernetes':
      return item.name;
    case 'domain':
    case 'bucket':
      return item.name;
    default:
      return '';
  }
};
</script>
